import NavigationBar from "../../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../../navigation/footer/footerComponent";
import ResidencyBody from "./residencyBody";

export default function MainResidencyComponent() {

    return (
        <div>
            <NavigationBar transparent />
            <ResidencyBody />
            <FooterComponent />
        </div>
    )
}
